export const MODAL_TYPE_POST_PENDING_APPROVAL = 'post-pending-approval';
